import { NgTemplateOutlet } from '@angular/common';
import {
    AfterViewInit,
    ChangeDetectionStrategy,
    Component,
    ComponentRef,
    Input,
    OnDestroy,
    Type,
    ViewChild,
    ViewContainerRef
} from '@angular/core';
import { PillComponent } from '../../../../pill/pill.component';
import { AddAttributesDirective } from '../../../bar/directives/add-attributes/add-attributes.directive';
import { Navigation } from '../../../bar/models/bar.type';

@Component({
    selector: 'nw-side-menu-child',
    templateUrl: './side-menu-child.component.html',
    styleUrls: ['./side-menu-child.component.scss'],
    imports: [PillComponent, AddAttributesDirective, NgTemplateOutlet],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SideMenuChildComponent<T = undefined> implements AfterViewInit, OnDestroy {
    @Input() label!: string;
    /** Renders the row as a link to this path. */
    @Input() path?: string;
    /** The link takes the row's tab stop, since it handles its own keyboard activation. */
    @Input() linkTabIndex?: number;
    @Input() badge?: Navigation.Badge;
    @Input() active: boolean = false;
    @Input() isGrandChild: boolean = false;
    @Input() isOrphan: boolean = false;
    @Input() dynamic?: {
        component: Type<T>;
        inputs: Partial<T>;
    };

    @ViewChild('dynamicContainer', { read: ViewContainerRef })
    dynamicContainer!: ViewContainerRef;

    private componentRef!: ComponentRef<T>;

    public ngAfterViewInit(): void {
        if (!this.dynamic) return;
        this.dynamicContainer?.clear();

        this.componentRef = this.dynamicContainer.createComponent(
            this.dynamic?.component,
            this.dynamic?.inputs
        );

        if (this.dynamic.inputs && this.componentRef?.instance) {
            Object.assign(this.componentRef.instance, this.dynamic.inputs);
            this.componentRef.changeDetectorRef.detectChanges();
        }
    }

    public ngOnDestroy(): void {
        if (this.componentRef) {
            this.componentRef.destroy();
        }
    }
}
